import script from "./ManageProductStorefrontModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageProductStorefrontModal.vue?vue&type=script&setup=true&lang=ts"

import "./ManageProductStorefrontModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__